import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import MuiButton from '@mui/material/Button'
import MuiCard from '@mui/material/Card'
import PageTitle from '../../components/page-title'
import AddImportDrawer from './components/addImportDrawer'
import { useGetImportsQuery } from './slice'

const Imports = () => {
  const navigate = useNavigate()
  const [drawerOpen, setDrawerOpen] = useState(false)
  const onAddImportClick = () => setDrawerOpen(true)
  const { data: imports } = useGetImportsQuery()
  const onImportClick = (imported) => () => {
    if (imported.status === 'awaiting') return
    navigate(`/prospects/imports/${imported.id}`)
  }

  const action = (
    <>
      <MuiButton variant="outlined" onClick={onAddImportClick}>
        Start New Import
      </MuiButton>
    </>
  )

  return (
    <div>
      <PageTitle title="Prospects :: Imports" action={action} />
      <AddImportDrawer drawerOpen={drawerOpen} setDrawerOpen={setDrawerOpen} />
      {imports?.map((imported) => (
        <MuiCard
          variant="outlined"
          key={imported.id}
          sx={{
            m: 1,
            p: 1,
            color: imported.status === 'error' ? 'red' : undefined,
            borderColor: imported.status === 'error' ? 'red' : 'grey',
          }}
          onClick={onImportClick(imported)}
        >
          {imported.filename} - {imported.status}
        </MuiCard>
      ))}
    </div>
  )
}

export default Imports
